import { Permission } from '@auth/permissionsEnum'

export const PermissionUtilsFactory = (permissions: unknown[]) => {
  const hasPermission = (permission: Permission) => permissions.includes(permission)
  const hasAllPermissions = (requiredPermissions: Permission[]) => requiredPermissions.every(hasPermission)
  const hasAnyPermission = (requiredPermissions: Permission[]) => requiredPermissions.some(hasPermission)

  return {
    hasPermission,
    hasAllPermissions,
    hasAnyPermission,
  }
}

const getAllPermissionForType = (permission: Permission): Permission | null => {
  const resourceType = permission.split(':')[0]

  return `${resourceType}:all` as Permission
}

export const EnhancedPermissionUtilsFactory = (studyPermissions: unknown[], globalPermissions: unknown[]) => {
  const hasPermission = (permission: Permission) => {
    const allPermission = getAllPermissionForType(permission)

    // Study membership: use study permissions only; resource:all satisfies any grant for that resource
    if (studyPermissions.length > 0) {
      if (studyPermissions.includes(permission)) return true
      return allPermission ? studyPermissions.includes(allPermission) : false
    }

    // No study membership: global resource:all grants access
    if (!allPermission) return false
    return globalPermissions.includes(allPermission)
  }

  const hasAllPermissions = (requiredPermissions: Permission[]) => requiredPermissions.every(hasPermission)

  const hasAnyPermission = (requiredPermissions: Permission[]) => requiredPermissions.some(hasPermission)

  return {
    hasPermission,
    hasAllPermissions,
    hasAnyPermission,
  }
}
